module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PromoterHome"
    }
  }, [_c('Background-Image', {
    attrs: {
      "url": "/woman-woods.jpg",
      "color": "#000"
    }
  }), _vm._v(" "), _c('Navigation', {
    attrs: {
      "hideLogo": "true",
      "backgroundColor": "transparent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid intro"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 sameHeight"
  }, [_c('router-link', {
    staticClass: "brand m-t-3",
    attrs: {
      "to": '/' + this.$store.state.language
    }
  }, [_vm._v("booknatura")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.t('A booking platform')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.t('for nature activities')))]), _vm._v(" "), _c('ul', {
    staticClass: "whyWeMatter m-t-4"
  }, [_c('li', [_vm._v(_vm._s(_vm.t('Search by activity, location or date')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.t('Allows easy and fast bookings')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.t('Accepts multiple payment methods')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 sameHeight mainActions text-sm-right"
  }, [_c('div', {
    staticClass: "primaryAction"
  }, [_c('router-link', {
    staticClass: "btn btn-primary m-b-1",
    attrs: {
      "to": '/' + this.$store.state.language + '/supplier/register'
    }
  }, [_vm._v(_vm._s(_vm.t('Supplier Registration')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "secundaryAction"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": '/' + this.$store.state.language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.t('Login')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "container-fluid m-t-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 m-b-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Increase your Bookings')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.t('Higher visibility for your activities in the national and international market')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.t('Enables instant confirmation of bookings')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.t('Ensure a flawless experience for your customers')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-b-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Save time and money')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n              " + _vm._s(_vm.t('Free access to management software'))), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                  " + _vm._s(_vm.t('Simple management of your bookings through your computer or smartphone')) + "\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                  " + _vm._s(_vm.t('Add or edit your activities whenever necessary')) + "\n                ")])])]), _vm._v(" "), _c('li', [_vm._v("\n              " + _vm._s(_vm.t('No fees or subscription')) + "\n              "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.t('Pay only a commission for bookings made through the platform')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-b-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Share our vision')))]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.t('We believe that all those who practice or organize tourism activities in nature should promote respect for the natural heritage and contribute to its conservation.')) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.t('Booknatura is designed to clients who enjoy contact with nature and seek more active, authentic and sustainable experiences.')) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "finale"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "roW"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-12 col-sm-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.t('Join us')))]), _vm._v(" "), _c('div', {
    staticClass: "secActionButtons"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": '/' + this.$store.state.language + '/supplier/register'
    }
  }, [_vm._v(_vm._s(_vm.t('Supplier Registration')))]), _vm._v(" "), _c('p', {
    staticClass: "or"
  }, [_c('small', [_vm._v(_vm._s(_vm.t('or')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-sm btn-contact",
    attrs: {
      "href": "mailto:info@booknatura.com"
    }
  }, [_vm._v(_vm._s(_vm.t('contact us')))])], 1)])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-363ad4b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-363ad4b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Promoter/PromoterHome.vue
// module id = 771
// module chunks = 3